import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play-icon",
  "use": "play-icon-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol viewBox=\"0 0 20 24\" id=\"play-icon\">\n      <path d=\"M0 22.2559V1.74409C0 0.971628 0.838527 0.490844 1.50518 0.881077L19.0257 11.137C19.6854 11.5232 19.6854 12.4768 19.0257 12.863L1.50518 23.1189C0.83853 23.5091 0 23.0284 0 22.2559Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol